import SpecialOfferSlider from "./components/sliders/SpecialOfferSlider.tsx";
import WeeklyTasksSlider from "./components/sliders/WeeklyTasksSlider.tsx";
import FilterTab from "../../components/common/filter/FilterTab.tsx";
import { Suspense, useEffect } from "react";
import CardLoading from "./components/cards/GetDonCardLoading";
import PageWrapper from "../../components/PageWrapper.tsx";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useNavigate } from "react-router";
import SwiperContent from "@/components/base/SwipeableWrapper.tsx";

const Loading = () => {
  return (
    <div className="py-4 overflow-hidden">
      <div className="container flex flex-col gap-6">
        <div>
          <div className="relative skeleton w-1/2 h-6 rounded-sm shrink-0 mb-3"></div>
          <div className="relative skeleton w-full h-[183px] rounded-xl shrink-0"></div>
        </div>
        <div>
          <div className="relative skeleton w-1/2 h-6 rounded-sm shrink-0 mb-3"></div>
          <div className="relative skeleton w-full h-[119px] rounded-xl shrink-0"></div>
        </div>
        <div className="flex gap-2">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div
              key={idx}
              className="relative skeleton w-28 h-[38px] rounded-full shrink-0"
            ></div>
          ))}
        </div>
        <div className="grid gap-1">
          {Array.from({ length: 3 }).map((_, idx) => (
            <CardLoading key={idx} />
          ))}
        </div>
      </div>
    </div>
  );
};

const ErrorHandler = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    toast.error(t("data_fetching_error"));
    navigate("/");
  }, [t, navigate]);

  return null;
};

export default function GetDonPage() {
  return (
    <ErrorBoundary FallbackComponent={ErrorHandler}>
      <Suspense fallback={<Loading />}>
        <BaseGetDonPage />
      </Suspense>
    </ErrorBoundary>
  );
}

function BaseGetDonPage() {
  return (
    <PageWrapper backPath="/">
      <div className="container flex flex-col gap-6 py-4">
        <SpecialOfferSlider />
        <WeeklyTasksSlider />
        <div className="flex flex-col gap-2">
          <FilterTab />
          <SwiperContent />
        </div>
      </div>
    </PageWrapper>
  );
}
